/* K MANNAM: per-order maximum quantity per product (product metafield custom.max_purchase_quantity).
 * Each product (single item or bundle product) has its own limit; lines of the same product are summed.
 * 1) Product page: the quantity picker stops at the limit.
 * 2) Any cart change (product page, quick view, product cards): lines above the limit are reduced and the
 *    customer is told. Storefront-only guard; "Buy it now" skips the cart, so a checkout validation rule is
 *    still needed for full enforcement.
 */
(function () {
  'use strict';
  if (window.KMQtyLimit) return;
  var ko = (document.documentElement.lang || 'ko').toLowerCase().indexOf('ko') === 0;
  var cartUrl = '/cart';
  try { cartUrl = JSON.parse(document.querySelector('[data-km-shipping-config]').textContent).cartUrl || '/cart'; } catch (e) {}
  var fixing = false, timer = 0;

  function t(k, e) { return ko ? k : e; }
  function notice(text) {
    var box = document.getElementById('km-qty-limit-notice');
    if (!box) {
      box = document.createElement('div');
      box.id = 'km-qty-limit-notice';
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
        'width:max-content;max-width:calc(100% - 32px);padding:12px 18px;border-radius:8px;background:#221f20;' +
        'color:#fff;font-size:14px;line-height:1.5;box-shadow:0 4px 18px rgba(0,0,0,.25);';
      document.body.appendChild(box);
    }
    box.textContent = text;
    box.hidden = false;
    clearTimeout(box.kmTimer);
    box.kmTimer = setTimeout(function () { box.hidden = true; }, 5000);
  }

  // ---- 1) Product page quantity picker -------------------------------------------------------
  function pageLimit(el) {
    var scope = el.closest('[data-section-type="product"]') || document;
    var row = scope.querySelector('[data-km-max-qty]');
    return row ? Number(row.getAttribute('data-km-max-qty')) || 0 : 0;
  }
  function limitMessage(max) { return t('이 상품은 1회 주문 시 최대 ' + max + '개까지 구매할 수 있습니다.', 'This item is limited to ' + max + ' per order.'); }
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-action="increase-picker-quantity"]');
    if (!plus) return;
    var selector = plus.closest('.quantity-selector');
    var input = selector && selector.querySelector('.quantity-selector__value');
    var max = input ? pageLimit(input) : 0;
    if (max && Number(input.value) >= max) {
      e.preventDefault();
      e.stopImmediatePropagation();
      notice(limitMessage(max));
    }
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.quantity-selector__value')) return;
    var max = pageLimit(input);
    if (max && Number(input.value) > max) {
      input.value = max;
      notice(limitMessage(max));
    }
  }, true);
  function markInputs() {
    document.querySelectorAll('form.product-form .quantity-selector__value').forEach(function (input) {
      var max = pageLimit(input);
      if (max) input.setAttribute('max', String(max));
    });
  }

  // ---- 2) Cart correction after any cart change ---------------------------------------------
  function readPayload(doc) {
    var nodes = doc.querySelectorAll('[data-km-cart-payload]');
    try { return JSON.parse(nodes[nodes.length - 1].textContent); } catch (e) { return null; }
  }
  async function check() {
    if (fixing) return;
    fixing = true;
    try {
      var url = new URL(cartUrl, location.origin);
      url.searchParams.set('section_id', 'km-shipping-data');
      url.searchParams.set('_kmq', String(Date.now()));
      var res = await window.fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!res.ok) return;
      var cart = readPayload(new DOMParser().parseFromString(await res.text(), 'text/html'));
      if (!cart || !Array.isArray(cart.items)) return;
      var byProduct = {};
      cart.items.forEach(function (item) {
        if (!(item.maxQty > 0)) return;
        (byProduct[item.productId] = byProduct[item.productId] || []).push(item);
      });
      var changes = [], names = [];
      Object.keys(byProduct).forEach(function (id) {
        var lines = byProduct[id], max = lines[0].maxQty;
        var excess = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0) - max;
        if (excess <= 0) return;
        names.push(lines[0].title + ' ' + t('(최대 ' + max + '개)', '(max ' + max + ')'));
        for (var i = lines.length - 1; i >= 0 && excess > 0; i--) { // trim the most recently added lines first
          var cut = Math.min(excess, lines[i].quantity);
          changes.push({ id: lines[i].key, quantity: lines[i].quantity - cut });
          excess -= cut;
        }
      });
      if (!changes.length) return;
      for (var j = 0; j < changes.length; j++) {
        await window.fetch(cartUrl + '/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(changes[j])
        });
      }
      notice(t('1회 주문 수량이 제한된 상품이라 수량을 조정했습니다: ', 'Quantity adjusted to the per-order limit: ') + names.join(', '));
      if (document.querySelector('[data-km-cart-v27]')) setTimeout(function () { location.reload(); }, 1500);
      else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    } catch (e) {
      console.warn('K MANNAM qty limit:', e);
    } finally {
      fixing = false;
    }
  }
  function schedule() { if (!fixing) { clearTimeout(timer); timer = setTimeout(check, 400); } }

  // Watch same-origin cart mutations (add/change/update) made by the theme, quick view or apps.
  var previousFetch = window.fetch.bind(window);
  window.fetch = function (resource, options) {
    var mutation = false;
    try {
      var url = new URL(typeof resource === 'string' ? resource : resource.url, location.origin);
      var method = String((options && options.method) || (resource && resource.method) || 'GET').toUpperCase();
      mutation = url.origin === location.origin && method !== 'GET' && /\/cart\/(add|change|update)(?:\.js)?\/?$/.test(url.pathname);
    } catch (e) {}
    var request = previousFetch(resource, options);
    if (mutation && !fixing) request.then(schedule, schedule);
    return request;
  };
  ['cart:updated', 'cart:rerendered'].forEach(function (name) { document.addEventListener(name, schedule, true); });

  window.KMQtyLimit = { check: check };
  function start() { markInputs(); schedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', markInputs);
})();
